/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Product document information
 * @export
 * @interface ProductDocumentDto
 */
export interface ProductDocumentDto {
    /**
     * Unique identifier of the document
     * @type {string}
     * @memberof ProductDocumentDto
     */
    id?: string;
    /**
     * Document label/designation
     * @type {string}
     * @memberof ProductDocumentDto
     */
    label?: string | null;
    /**
     * URL to access the document
     * @type {string}
     * @memberof ProductDocumentDto
     */
    url?: string | null;
}

/**
 * Check if a given object implements the ProductDocumentDto interface.
 */
export function instanceOfProductDocumentDto(value: object): value is ProductDocumentDto {
    return true;
}

export function ProductDocumentDtoFromJSON(json: any): ProductDocumentDto {
    return ProductDocumentDtoFromJSONTyped(json, false);
}

export function ProductDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'] == null ? undefined : json['label'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function ProductDocumentDtoToJSON(json: any): ProductDocumentDto {
    return ProductDocumentDtoToJSONTyped(json, false);
}

export function ProductDocumentDtoToJSONTyped(value?: ProductDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'url': value['url'],
    };
}

